module.exports = __webpack_public_path__ + "static/img/氟水换热器.dd64a631.png";